
import { WebsiteCategoriesTable } from "./WebsiteCategoriesTable";

export const CategoriesSection = () => {
  return <WebsiteCategoriesTable />;
};
